import React, { useState } from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Stack,
    Link,
    styled
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchIcon from '@mui/icons-material/Search';
import PublicIcon from '@mui/icons-material/Public';
import BarChartIcon from '@mui/icons-material/BarChart';
import AddIcon from '@mui/icons-material/Add';
import LaunchIcon from '@mui/icons-material/Launch';
import useScreenSize from "./UserScreenSize";
import { AppAlertBox } from './AppAlertBox';

import { AccountLayout } from './../_pages/essentials/account'


import {history, uxscreen} from "../_services/essentials/helpers";
import AppTheme from "./shared-theme/AppTheme";
import CssBaseline from "@mui/material/CssBaseline";
import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations
} from "./theme/customizations";

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
};


export { WebLayout };

function WebLayout(props) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const screenSize = useScreenSize();

    const handleSignIn = (e) => {
        e.preventDefault();
        console.log('Signing in with:', { email, password });
    };

    const GradientTypography = styled(Typography)({
        background: 'linear-gradient(to right bottom, #272489, #5c59dc, #f64f59, #3895e5)',

        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        display: 'inline-block', // Recommended to prevent layout clipping
    });

    return (
        <Box
            sx={{
                background: 'linear-gradient(to right bottom, #ffffff, #a29bfe, #7f5dea,  #7f5dea, #e57ba5)',
                display: 'flex',
                alignItems: 'center',
                py: 2,
                //overflowX: 'hidden',
                minHeight: screenSize.height
            }}
        >
            <AppAlertBox />
            <Container maxWidth="xl">
                <Grid container spacing={4}>

                    {/* Left Content Column */}
                    <Grid size={{ xs: 12, md: 7 }} sx={{ height: '100%', pr: { md: 6 } }}>

                        {/* Top Navigation Row */}
                        <Stack sx={{ mb: 6 }}>
                            <Link sx={{cursor: 'pointer'}} href="https://www.keyinsightdata.com/">
                                <img
                                    src="../assets/images/healthcare/keyinsight_data_logo.png"
                                    alt="KeyInsight Data Logo"
                                    style={{ height: '80px', }}
                                />
                            </Link>
                        </Stack>

                        {/* Brand Logo Header */}
                        <Stack direction="row" spacing={1.5} sx={{ mb: 2, alignItems:"center" }}>
                            <img
                                src="../assets/images/healthcare/oncoInsight_logo.png"
                                alt="KeyInsight Data Logo"
                                style={{ height: '106px', justifyContent: 'center' }}
                            />
                        </Stack>

                        <Stack sx={{ mb: 4 }}>
                            <Typography
                                variant="h2"
                                component="h2"
                                sx={{
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    mb: 1,
                                    fontSize: { xs: '2rem', md: '3rem' },
                                    lineHeight: 1.25,
                                }}
                            >
                                Empowering
                            </Typography>
                            <GradientTypography sx={{
                                fontSize: { xs: '2rem', md: '3rem' },
                                fontWeight: 'bold',
                            }}>Oncology Intelligence</GradientTypography>

                            {/* Subtitle Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    mb: 3,
                                    maxWidth: '540px',
                                    lineHeight: 1.6
                                }}
                            >
                                Discover, profile, and engage the world's leading oncology Key Opinion Leaders with precision data intelligence.
                            </Typography>
                        </Stack>
                        {/* Feature Bullet Points */}
                        <Stack spacing={2}>
                            <Stack direction="row" spacing={1} sx={{alignItems:"center"}}>
                                <Box sx={{ color: '#a00000', display: 'flex' }}><SearchIcon /></Box>
                                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                    80,873 oncology KOL profiles globally
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1} sx={{alignItems:"center"}}>
                                <Box sx={{ color: '#a00000', display: 'flex' }}><PublicIcon /></Box>
                                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                    42 countries 18 specialties covered
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1} sx={{alignItems:"center"}}>
                                <Box sx={{ color: '#a00000', display: 'flex' }}><BarChartIcon /></Box>
                                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                    360° profiling with publications & trials data
                                </Typography>
                            </Stack>
                        </Stack>
                    </Grid>

                    <AccountLayout/>


                </Grid>
            </Container>
        </Box>
    );
}
